import { render, staticRenderFns } from "./agency-description.component.vue?vue&type=template&id=87fad9b4&"
import script from "./agency-description.component.ts?vue&type=script&lang=ts&"
export * from "./agency-description.component.ts?vue&type=script&lang=ts&"
import style0 from "./agency-description.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports